import React, { memo } from 'react';
import PropTypes from 'prop-types';

import { compose } from 'redux';
import { connect } from 'react-redux';

import { useInjectReducer } from 'utils/injectReducer';
import { useInjectSaga } from 'utils/injectSaga';

import saga from './saga';
import reducer from './reducer';

export function ReportsProvider({ children }) {
  useInjectSaga({ key: 'reportsProvider', saga });
  useInjectReducer({ key: 'reportsProvider', reducer });

  return React.Children.only(children);
}

ReportsProvider.propTypes = {
  children: PropTypes.element,
};

const withConnect = connect();

export { default as useReports } from './useReports';
export { default as withReports } from './withReports';
export default compose(withConnect, memo)(ReportsProvider);
